/**
 * Fonts Ninja — identify and try fonts on any page
 *
 * Declares a single web-accessible-resource group covering extension.bundle.js,
 * frame.html, icons/*, img/*, and all .woff / .woff2 files, matched to every http(s)
 * origin with no `use_dynamic_url` — so each bundled file is fetchable from any page at
 * a stable URL.
 *
 * icons/icon-128.png is the cleanest signal: an image loaded through `probeImage` with
 * no CORS grant, so it survives a restrictive page CSP and is conclusive — the file is
 * served only when the extension is installed.
 *
 * Manifest verified against version 8.0.4.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'eljapbgkmlngdpckoiiibecpemleclhh';

export const fontsNinja: ExtensionDefinition = {
  id: ID,
  name: 'Fonts Ninja',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 900_000,
  notes:
    'One static WAR group on every http(s) origin, no dynamic URL. The icon image and ' +
    'the vendor-named FontsNinja icon font make detection conclusive and CORS-free.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load icons/icon-128.png via <img> — exposed to every origin and readable ' +
        'without a CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'icons/icon-128.png'),
    },
    {
      id: 'war-fontsninja-icon-font',
      kind: 'web-accessible-resource',
      description:
        'Fetch fonts/FontsNinjaV3-Icons.woff — a vendor-named icon font, distinctive to ' +
        'Fonts Ninja and independent of the icon image.',
      weight: 0.5,
      run: () => probeFetch(ID, 'fonts/FontsNinjaV3-Icons.woff'),
    },
    {
      id: 'war-extension-bundle',
      kind: 'web-accessible-resource',
      description:
        'Fetch extension.bundle.js — the stable, non-hashed content-script bundle name ' +
        'exposed to every origin.',
      weight: 0.5,
      run: () => probeFetch(ID, 'extension.bundle.js'),
    },
  ],
};
